import { createFileRoute } from "@tanstack/react-router";

import { PersonalOnboardingContainer } from "@/features/onboarding/containers/personal-onboarding-container";

export const Route = createFileRoute("/onboarding/personal")({
  component: PersonalOnboardingContainer,
});
